'use client';

import { trackEvent } from '@/src/lib/amplitude';
import { AmplitudeEvents } from '@/src/lib/amplitude/events';
import { useEffect } from 'react';

export const TriggerSearchStores = () => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const searchParams = new URLSearchParams(window.location.search);
      const query = searchParams.get('q');
      if (query) {
        trackEvent(AmplitudeEvents.search_performed_in_shops, {
          search_keyword: query,
        });
      }
    }
  }, []);

  return null;
};
